import React, { useContext, useEffect, useRef, useState } from "react";
import { useForm, useStep } from "react-hooks-helper";

import DependentesSuccess from "pages/DependentesSuccess";
import DependentesConfirmPage from "pages/DependentesConfirmPage";
import ListNumbers from "pages/ListNumbersPage";
import DependenteCpf from "pages/DependenteCpfPage";
import Loading from "components/Loading";
import Analytics from "core/Utils/Analytics";
import { store } from "store.js";

const steps = [
  { id: "listNumbers" },
  { id: "confirm" },
  { id: "inputDependenteCpf" },
  { id: "success" },
];

const defaultData = {};

const Dependentes = ({ defaultStep, images }) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { dispatch } = globalState;
  const [formData, setForm] = useForm(defaultData);
  const { step, navigation } = useStep({ initialStep: 0, steps });
  const { id } = step;
  const [isLoading, setIsLoading] = useState(false);
  const [customData, setCustomData] = useState(defaultData);
  const props = {
    formData,
    setForm,
    navigation,
    setIsLoading,
    isLoading,
    setCustomData,
    customData,
  };
  let View = null;
  useEffect(function(){
    Analytics().setVirtualPageView();
    dispatch({
      type: "SET_GA",
      payload: { currentFlow: 'meus-numeros' },
    });
  },[dispatch])
  switch (id) {
    case "listNumbers":
      View = <ListNumbers {...props} />;
      break;
    case "confirm":
      View = <DependentesConfirmPage {...props} />;
      break;
    case "success":
      View = <DependentesSuccess {...props} />;
      break;
    case "inputDependenteCpf":
      View = <DependenteCpf {...props} />;
      break;
    default:
      View = null;
  }
  return (
    <>
      <Loading isLoading={isLoading} />
      {View}
    </>
  );
};

export default Dependentes;
